import { getStaticPathsForLocales } from '../../../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { PartialAmendDetailsPage } from '../../../../../features/parking/ui/booking-pages/partial-amend/PartialAmendDetailsPage';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = () => ({ props: {} });

export default PartialAmendDetailsPage;
